// 其他非核心功能
import { RouteConfig } from 'vue-router';
import { NewVersionEnum } from '@/enums/newVersionRoute';
import { RouterV2Enum } from '../router-names';

export default (): RouteConfig[] => ([
  // 对外不会直接投放 index.html#/，所以线上场景不会使用到RedirectHome组件
  {
    path: '/',
    name: 'RedirectHome',
    component: () => import(/* webpackChunkName: "others" */ '@/viewsH5/redirect'),
    meta: {
      pageId: 'APP_白页',
      needLogin: false,
    },
  },

  {
    path: RouterV2Enum.aboutUs,
    name: 'aboutUs',
    component: () => import(/* webpackChunkName: "others" */ '@/views_v2/about-us'),
    meta: {
      pageId: '臻有钱_了解我们',
      title: '了解我们',
    },
  },

  {
    path: RouterV2Enum.aboutUsList,
    name: 'aboutUsList',
    component: () => import(/* webpackChunkName: "others" */ '@/views_v2/about-us-list'),
    meta: {
      pageId: '臻有钱_关于我们',
      title: '关于我们',
    },
  },

  {
    path: RouterV2Enum.helpCenter,
    name: 'helpCenter',
    meta: {
      pageId: '臻有钱_帮助中心',
      newRedirect: NewVersionEnum.HELPER_CENTER,
      title: '帮助中心',
    },
  },
  {
    path: RouterV2Enum.campaignShare,
    name: 'campaignShare',
    component: () => import(/* webpackChunkName: "others" */ '@/views_v2/campaign-share'),
    meta: {
      pageId: '臻有钱_邀请好友活动页',
      title: '邀请好友',
    },
  },

  {
    path: RouterV2Enum.feedBack,
    name: 'feedBack',
    meta: {
      pageId: '臻有钱_意见反馈_选择问题类型',
      newRedirect: NewVersionEnum.FEEDBACK,
      title: '选择问题类型',
    },
  },

  {
    path: RouterV2Enum.toolBox,
    name: 'toolBox',
    component: () => import(
      /* webpackChunkName: "others" */ '@/views_v2/tool-box'
    ),
    meta: {
      pageId: '臻有钱_贷款计算器输入页',
      title: '贷款计算器',
    },
  },

  {
    path: RouterV2Enum.toolBoxResult,
    name: 'toolBoxResult',
    component: () => import(
      /* webpackChunkName: "others" */ '@/views_v2/tool-box-result'
    ),
    meta: {
      pageId: '臻有钱_贷款计算器结果页',
      title: '计算结果',
    },
  },

  {
    path: RouterV2Enum.setting,
    name: 'setting',
    component: () => import(/* webpackChunkName: "others" */ '@/views_v2/setting'),
    meta: {
      pageId: '臻有钱_设置',
      title: '设置',
    },
  },

  {
    path: RouterV2Enum.security,
    name: 'security',
    meta: {
      pageId: '臻有钱_账户安全',
      title: '账户安全',
      newRedirect: NewVersionEnum.SECURITY,
    },
  },

  {
    path: RouterV2Enum.usingGuid,
    name: 'usingGuid',
    component: () => import(
      /* webpackChunkName: "others" */ '@/views_v2/using-guid'
    ),
    meta: {
      pageId: 'finance_usingGuid',
      title: '臻有钱',
      desc: '使用指南',
      needLogin: false,
    },
  },

  {
    path: RouterV2Enum.antiFraudCenter,
    name: 'antiFraudCenter',
    component: () => import(
      /* webpackChunkName: "others" */ '@/views_v2/fraud'
    ),
    meta: {
      pageId: 'finance_loan_fraudPreventionGuidelines',
      title: '臻有钱',
      desc: '防诈指南',
      isShowH5Nav: true,
    },
  },

  {
    path: RouterV2Enum.additionalInfo,
    name: 'additionalInfo',
    component: () => import(
      /* webpackChunkName: "additional-info" */ '@/views_v2/additional-info'
    ),
    meta: {
      pageId: 'finance_loan_addInformation',
      title: '补充资料',
    },
  },

  {
    path: RouterV2Enum.supplementInfo,
    name: 'supplementInfo',
    component: () => import(
      /* webpackChunkName: "supplement-info" */ '@/views_v2/supplement-info'
    ),
    meta: {
      pageId: 'finance_loan_addInformation',
      title: '补充资料',
    },
  },

  {
    path: RouterV2Enum.accountTypeInfo,
    name: 'accountTypeInfo',
    component: () => import(
      /* webpackChunkName: "account-type-info" */ '@/views_v2/account-type-info'
    ),
    meta: {
      pageId: 'finance_loan_cardTypePrompt',
      title: '',
      isShowH5Nav: true,
      controlNav: true,
      navBarCustomProps: {
        background: 'transparent',
        isShowAndroidStatusBar: false,
        isDarkStatusBar: false,
      },
    },
  },

  {
    path: RouterV2Enum.withdrawalWaiting,
    name: 'withdrawalWaiting',
    component: () => import(/* webpackChunkName: "withdrawal-waiting" */ '@/views_v2/withdrawal-waiting/index.vue'),
    meta: {
      pageId: 'finance_loan_CardLimitPage',
      title: '提现等待',
      isShowH5Nav: true,
      /** isShowCoffeeH5Nav配置为true是，isShowH5Nav也要配置为true */
      isShowCoffeeH5Nav: true,
      navbar: {
        titleIsCenter: true,
      },
    },
    props: (route) => ({
      capitalCode: String(route.query.capitalCode || ''),
      loanOrderId: String(route.query.loanOrderId || ''),
    }),
  },
]);
